export default
{
    "members": [
        {
            "name": "John Doe",
            "position": "General Manager",
            "img": "Doe.jpg",
            "links": {
                "facebook": "",
                "twitter": "",
                "messenger": "",
                "sthElse": ""
            }
        },
        {
            "name": "Alexa Biru",
            "position": "Office Director",
            "img": "Biru.jpg",
            "links": {
                "facebook": "",
                "twitter": "",
                "messenger": "",
                "sthElse": ""
            }
        },
        {
            "name": "Ronobir Sing",
            "position": "Admin",
            "img": "Sing.jpg",
            "links": {
                "facebook": "",
                "twitter": "",
                "messenger": "",
                "sthElse": ""
            }
        },
        {
            "name": "Not John Doe",
            "position": "General Manager",
            "img": "Biru.jpg",
            "links": {
                "facebook": "",
                "twitter": "",
                "messenger": "",
                "sthElse": ""
            }
        },
        {
            "name": "Not Alexa Biru",
            "position": "Office Director",
            "img": "Sing.jpg",
            "links": {
                "facebook": "",
                "twitter": "",
                "messenger": "",
                "sthElse": ""
            }
        },
        {
            "name": "Not Ronobir Sing",
            "position": "Admin",
            "img": "Doe.jpg",
            "links": {
                "facebook": "",
                "twitter": "",
                "messenger": "",
                "sthElse": ""
            }
        },
        {
            "name": "Not Not John Doe",
            "position": "General Manager",
            "img": "Sing.jpg",
            "links": {
                "facebook": "",
                "twitter": "",
                "messenger": "",
                "sthElse": ""
            }
        },
        {
            "name": "Not Not Alexa Biru",
            "position": "Office Director",
            "img": "Doe.jpg",
            "links": {
                "facebook": "",
                "twitter": "",
                "messenger": "",
                "sthElse": ""
            }
        },
        {
            "name": "Not Not Ronobir Sing",
            "position": "Admin",
            "img": "Biru.jpg",
            "links": {
                "facebook": "",
                "twitter": "",
                "messenger": "",
                "sthElse": ""
            }
        }
    ]
}